// extracted by mini-css-extract-plugin
module.exports = {"footerInfoWrap":"FooterInfo_footerInfoWrap__IeCPw","footerInfoItem":"FooterInfo_footerInfoItem__0Lubm","footerInfoTitle":"FooterInfo_footerInfoTitle__QYmZv"};